import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useGetCtasQuery } from "../../hooks/useGetCtasQuery";
import { updateCta } from "../../services/school/cta/updateCta";
import { CtaType } from "../../types/Cta";
import { Key_ctas } from "../../utils/constants";

const columnNamesMap: { [key: string]: string } = {
  fullname: "Nome",
  role: "Cargo",
};

export const Ctas = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItem, setDeleteItem] = useState<CtaType | null>(null);

  const queryClient = useQueryClient();
  const { data, status } = useGetCtasQuery({ PageNumber: currentPage, PageSize: 400 });

  const mutationDelete = useMutation(updateCta, {
    onSuccess: () => {
      queryClient.invalidateQueries(Key_ctas);
      toast.success('Apagado');
    },
    onError: () => {
      toast.error("Erro ao apagar.")
    }
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleEdit = async (cta: CtaType) => {
  };
  const handleDelete = (cta: CtaType) => {
    try {
      cta.status = false;
      mutationDelete.mutateAsync(cta)
    } catch (error: any) {
      toast.error(`${mutationDelete.error ?? error?.message}`);

    }
  };
  const openDeleteItemDialog = (s: CtaType) => {
    setDeleteItem(s);
  };
  const confirmDeleteItem = async () => {
    if (deleteItem) {
      await handleDelete(deleteItem!)
    }
  };
  const options = data?.items.map(() => [
    {
      label: 'Editar',
      onClick: (manager: any) => handleEdit(manager),
      icon: <Pencil1Icon />
    },
    {
      label: 'Excluir',
      onClick: (manager: any) => openDeleteItemDialog(manager),
      icon: <TrashIcon />
    }
  ]) || [];

  return (
    <>
      <Lists
        status={status}
        TableComponent={() =>
          <TableComponent
            columns={Object.keys(columnNamesMap)}
            items={data?.items}
            options={options}
            columnNamesMap={columnNamesMap}
            totalPages={data?.totalPages || 1}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        }
        handleClickCreate={undefined}
      />
      <ConfirmAlertDialog
        open={!!deleteItem}
        onOpenChange={(open) => !open && setDeleteItem(null)}
        title="Esta operação é irreversível"
        item={deleteItem}
        onConfirm={confirmDeleteItem}
        onCancel={() => setDeleteItem(null)}
      />
    </>
  );
}